import React, { useEffect, useState } from "react";
import { db } from "../../base";

const ListCatalogues = ({ catalogue, categorys, collection }) => {
  const [listCatalogues, setListCatalogues] = useState([]);
  const [showModal, setShowModal] = useState("");

  useEffect(() => {
    db.collection(collection)
      .where("category", "==", catalogue.category)
      .onSnapshot((snapshot) => {
        setListCatalogues(
          snapshot.docs.map((doc) => ({
            key: doc.id,
            id: doc.id,
            name: doc.data().name,
            category: doc.data().category,
            url: doc.data().url,
          }))
        );
      });
  }, []);

  if (listCatalogues[0]) {
    return (
      <div>
        <h2>{catalogue.category}</h2>
        {listCatalogues.map((list) => (
          <a href={list.url} target="_blank">
            {list.name}
          </a>
        ))}
      </div>
    );
  }

  return (
    <div>
      <h2>{catalogue.category}</h2>
      Il n'y a pas de catalogue dans cette catégorie
    </div>
  );
};

export default ListCatalogues;
